import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@fortawesome/fontawesome-free/css/all.css'
Vue.config.productionTip = false


setTimeout(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
    
  }).$mount('#vue_app')
}, 2000);